module.exports = __webpack_public_path__ + "img/switch-camera.365ec373.svg";